module.exports = __webpack_public_path__ + "static/img/chevron-up-black.c6f4062f.svg";